import React from "react";
import Card from "../../../../core/Card";
import Typography from "../../../../core/Typography";
import { useDevice } from "../../../customHooks";
import { useEffect, useRef, useState } from "react";
import style from "../../../style.module.css";
import { Icon } from "@blueprintjs/core";
import loading from "../../../../assets/loading.svg";
import { useNavigate } from 'react-router-dom'

// import Header from "../../survey/survey-form/landing-page/widgets/Header";
import Axios from "axios";
import Title from "../Title";
// routes
import { Link } from "react-router-dom";

export const ProcessDone = () => {
  let device = useDevice();
  const [isOpen, setOpen] = useState(false);
  const inputRef = useRef();
  const [count, setCount] = useState(0);
  const [isChecked, setChecked] = useState(false);
  const navigate = useNavigate();

  const urlParams = new URLSearchParams(window.location.search);
  let email = urlParams.get('email');

  useEffect(() => {
    const str = String(inputRef?.current?.props.value)?.length;
    setCount(str);

    //redirecting
     setTimeout(() => {
      // navigate('/')
      Axios.get(process.env.REACT_APP_NODE_API_URL + "/users/LoginAfterSignup?email="+email, {
        email: email,
      }).then((response) => {
         if(response.status==200){
          localStorage.setItem('token_id', response.data.token_id);
          navigate('/admin/survey/list')
         }
      });
    }, 2500)
  }, []);

  const handleCount = e => {
    setCount(String(e.target.value).length);
  };
  return (
    <>
      <div className='d-flex flex-column site-main-wrapper login-page'>
        {/* <Header /> */}
        <div className="flex-grow-1 main-content-wrap d-flex align-items-center justify-content-center">
          <div className="container">
            <div className="form-wrapper">
              <div className="form-heading text-center mb-0">
                <div className="procee-center">
                  <img src={loading} alt="Loading" />
                </div>
                <h3>Please wait...</h3>
                <p>While we are setting up your account</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProcessDone;
